//!#system	

<template>
	<div :key="containerKey">
		<div v-if="!hasFullUser && !isLoading">
			<v-avatar
				color="indigo"
				size="36"
			>
				<v-img v-if="imageUrl" :src="imageUrl" :size="36" />
				<span v-if="initialsString" class="white--text">{{initialsString}}</span>
			</v-avatar>
		</div>
		<div v-else-if="!isLoading">
			<v-menu
				v-model="userCard"
				:close-on-content-click="false"
				:nudge-width="200"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-avatar
						color="indigo"
						size="36"
						v-bind="attrs"
						v-on="on"
					>
						<v-img v-if="imageUrl" :src="imageUrl" :size="36" />
						<span v-if="initialsString" class="white--text">{{initialsString}}</span>
					</v-avatar>
				</template>
				<v-card>
					<v-list>
						<v-list-item>
							<v-list-item-avatar
								color="indigo"
								size="72"
							>
								<v-img v-if="imageUrl" :src="imageUrl" :size="72" />
								<span v-if="initialsString" class="white--text headline">{{initialsString}}</span>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title>{{userData.username}}</v-list-item-title>
								<v-list-item-subtitle>{{userData.name}}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-divider v-if="isMyAccount"></v-divider>
					<v-list v-if="isMyAccount">
						<v-list-item>
							<v-list-item-action>
								<v-btn small text @click="updatePasswordModal = true">Update my password</v-btn>
							</v-list-item-action>
						</v-list-item>
						<v-list-item>
							<v-list-item-action>
								<v-btn small text @click="updateAvatarModal = true">Update my avatar</v-btn>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-card>
			</v-menu>
		</div>
		<div v-else><!-- it is loading -->
			<v-progress-circular
				indeterminate
				color="amber"
				:size="36"
			></v-progress-circular>
		</div>
		<v-dialog v-model="updatePasswordModal" max-width="400" :key="updatePasswordKey" @click:outside="resetPasswordModal">
			<user-password-reset @saved="resetPasswordModal" />
		</v-dialog>
		<v-dialog v-model="updateAvatarModal" max-width="500" :key="updateAvatarKey" @click:outside="resetAvatarModal">
			<user-avatar-update @saved="resetAvatarModal" />
		</v-dialog>
	</div>
</template>

<script>
import tools from '@/tools';
import UserPasswordReset from './UserPasswordReset';
import UserAvatarUpdate from './UserAvatarUpdate';
export default {
	name: 'User',
	components: {
		UserPasswordReset,
		UserAvatarUpdate
	},
	props: {
		user: { // if you have the whole user object
			type: Object,
			default: () => { return {}; }
		},
		id: { // if you only have the user ID (slower, since we will need to get the user via the API)
			type: String,
			default: ''
		},
		avatarUrl: { // if you have the avatarUrl and you just want to show it (no interactivity)
			type: String,
			default: ''
		},
		initials: { // if you have the initials and you just want to show them (no interactivity)
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'avatar'
		}
	},
	data() {
		return {
			userData: {
				id: '',
				username: '',
				emailAddress: '',
				name: '',
				initials: '',
				userType: {
					type: ''
				},
				groups: [],
				avatar: {
					servePath: ''
				}
			},
			isLoading: false,
			doingFormSubmission: false,
			userCard: false,
			updatePasswordModal: false,
			updatePasswordKey: tools.randomString(),
			updateAvatarModal: false,
			updateAvatarKey: tools.randomString()
		}
	},
	computed: {
		imageUrl() {
			if (this.userData && this.userData.avatar && this.userData.avatar.servePath) return this.userData.avatar.servePath;
			if (this.avatarUrl) return this.avatarUrl;
			return '';
		},
		initialsString() {
			if (this.imageUrl) return '';
			if (this.userData.initials) return this.userData.initials;
			if (this.initials) return this.initials;
			return '';
		},
		hasFullUser() {
			return !!this.userData.id;
		},
		containerKey() {
			let keytype = '-user';
			if (this.user.id) return this.user.id + keytype;
			if (this.id) return this.id + keytype;
			if (this.userData.id) return this.userData.id + keytype;
			if (this.imageUrl) return this.imageUrl + keytype;
			return tools.randomString() + keytype;
		},
		isMyAccount() {
			return this.$store.getters['authentication/currentUser'].id === this.userData.id;
		},
		mailToLink() {
			if (!this.userData.emailAddress) return '';
			return 'mailto:' + encodeURIComponent(this.userData.emailAddress) + '';
		}
	},
	methods: {
		populateUser(u) {
			if (!u) return;
			if (u.id) {
				for (let key in u) {
					if (key in this.userData) {
						this.userData[key] = u[key];
					}
				}
			}
		},
		resetPasswordModal() {
			this.updatePasswordModal = false;
			this.updatePasswordKey = tools.randomString();
		},
		resetAvatarModal() {
			this.updateAvatarModal = false;
			this.updateAvatarKey = tools.randomString();
			this.getUserData({ refresh: true });
		},
		getUserData(options) {
			if (!options) options = {};
			let refresh = !!options.refresh;
			this.isLoading = true;
			this.$store.dispatch('authentication/userGet', { 
				id: this.id || this.userData.id, 
				refresh,
				callback: (err, user) => {
					this.isLoading = false;
					if (err) return;
					this.populateUser(user);
				}
			});
		}
	},
	created() {
		this.populateUser(this.us)
		if (this.user.id) {
			this.populateUser(this.user);
		}
		if (!this.user.id && !this.id) {
			// assume it's current user
			this.userData = this.$store.getters['authentication/currentUser'];
		}
		if (!this.userData.id && this.id) {
			// get it from the store
			this.getUserData();
		}
	}
}
</script>